import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';

const menuMap = {
  Management: [
    { path: '', label: 'Dashboard' },
    { path: 'employee-attendance', label: 'Employee Attendance' },
    { path: 'create-customer', label: 'Create Customer' },
    { path: 'employee-management', label: 'Employee Management' },
    { path: 'leave-management', label: 'Leave Management' },
    { path: 'salary-management', label: 'Salary Management' },
    { path: 'today-followup', label: 'Today Followup' },
    { path: 'followup-list', label: 'Followup List' },
    { path: 'due-customer', label: 'Due Customer' },
    { path: 'total-customer', label: 'Total Customer' },
    { path: 'notices', label: 'Create Notices' },
    { path: 'holidayManager', label: 'Holiday Manager' },
    { path: 'Salary-Advance', label: 'Salary Advance' },
    { path: 'projects_details', label: 'Projects Details' },
  ],
  Sales: [
    { path: '', label: 'Dashboard' },
    { path: 'attendance', label: 'Attendance' },
    { path: 'my-attendance', label: 'My Attendance' },
    { path: 'create-customer', label: 'Create Customer' },
    { path: 'today-sales-followup', label: 'Today Followup' },
    { path: 'followup-list', label: 'Followup List' },
    { path: 'done-list', label: 'Done List' },
    { path: 'leave-application', label: 'Leave Application' },
    { path: 'my-leaves', label: 'My Leaves' },
    { path: 'my-salary-slips', label: 'My Salary Slips' },
    { path: 'profile', label: 'Profile' },
     { path: 'All-Projects', label: 'All Projects' },
  ],
  Developer: [
    { path: '', label: 'Dashboard' },
    { path: 'attendance', label: 'Attendance' },
    { path: 'my-attendance', label: 'My Attendance' },
    { path: 'new-project', label: 'New Project' },
    { path: 'old-project', label: 'Old Project' },
    { path: 'complete-project', label: 'Complete project' },
    { path: 'leave-application', label: 'Leave Application' },
    { path: 'my-leaves', label: 'My Leaves' },
    { path: 'my-salary-slips', label: 'My Salary Slips' },
    { path: 'profile', label: 'Profile' },
    { path: 'All-Projects', label: 'All Projects' },
  ],
};

export default function Sidebar({ user, isOpen, onToggle, onLogout, mobileOverlayClose }) {
  const menus = menuMap[user?.department] || [];
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('employee');
    if (onLogout) onLogout();
    navigate('/login');
  };

  return (
    <aside
      className={`fixed top-0 left-0 h-screen bg-gray-900 text-white z-50 shadow-lg transition-all duration-300 ${
        isOpen ? 'w-56' : 'w-16'
      }`}
    >
      {/* Toggle Button */}
      <div
        onClick={onToggle}
        className="flex items-center justify-center h-14 border-b border-gray-700 cursor-pointer"
        title={isOpen ? 'Collapse Sidebar' : 'Expand Sidebar'}
      >
        <span className="text-xl font-semibold">{isOpen ? '«' : '»'}</span>
      </div>

      {/* Menu List with scroll */}
      <nav className="overflow-y-auto max-h-[calc(100vh-110px)] px-2 py-3">
        {menus.map(({ path, label }) => (
          <NavLink
            key={path || label}
            to={`/dashboard/${path}`}
            title={label}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-4 py-2 rounded-md mb-1 transition-all duration-200 ${
                isActive
                  ? 'bg-blue-600 text-white font-medium'
                  : 'text-gray-200 hover:bg-gray-700 hover:text-white'
              }`
            }
            onClick={() => {
              if (window.innerWidth < 768 && mobileOverlayClose) mobileOverlayClose();
            }}
          >
            <span className="truncate">{isOpen ? label : label.charAt(0)}</span>
          </NavLink>
        ))}
      </nav>

      {/* Logout Button */}
      <div className="border-t border-gray-700 p-3">
        <button
          onClick={() => {
            handleLogout();
            if (window.innerWidth < 768 && mobileOverlayClose) mobileOverlayClose();
          }}
          className="flex items-center justify-center w-full gap-2 bg-red-600 hover:bg-red-700 text-white py-2 px-3 rounded text-sm transition-all duration-150"
        >
          <LogOut size={16} />
          {isOpen && 'Logout'}
        </button>
      </div>
    </aside>
  );
}
